export const convertDataServingRequestsSmaregi = (data = []) => {
  const initData = []

  // Bước 1: Tìm các request có status là "pending"
  const pendingRequests = data.find((item) => item.status === 'pending')?.requests || []
  // Bước 2: Tìm đối tượng có status là "confirmed"
  const confirmedRequests = data.find((item) => item.status === 'confirmed')?.requests || []
  // Bước 3: Tìm ra data cancelled
  const cancelled = data.find((item) => item.status === 'cancelled')

  const activeRequests = confirmedRequests.concat(pendingRequests)
  if (activeRequests.length > 0)
    initData.push({
      status: 'confirmed',
      requests: activeRequests,
    })

  if (cancelled) initData.push(cancelled)

  return initData
}
